// NOTE: reference image height is a value that was found heuristically.
// It appears for example that font size 25 is 25 pixels if video height
// is 312. If the video height is different, it is scaled accordingly.
export const REFERENCE_IMAGE_HEIGHT = 312;
export const getRelativeSubsFontSize = (originalSize, containerHeight) => {
    return (originalSize / REFERENCE_IMAGE_HEIGHT) * containerHeight;
};
